function getPrettyNumberFormat(n, options = {}) {
  const { defaultVal = "-", maxFract = 6 } = options;
  const precision = 3;
  const num = Number(n);

  if (typeof n !== "number" && typeof n !== "string") return defaultVal;
  if (Number.isNaN(num)) return defaultVal;
  if (!Number.isFinite(num)) return String(n);

  const intPart = Math.round(num);
  const affected = num.toPrecision(precision);
  const fixedFractional = parseFloat(affected - intPart).toFixed(maxFract);
  const fixedNum = parseFloat(fixedFractional);
  const fractional = fixedNum % 1;
  const final = fractional + intPart;
  return final.toLocaleString("en", { maximumFractionDigits: 15 });
}

export default getPrettyNumberFormat;
